<template>
  <label
    v-for="item in props.items"
    :key="item.key"
    :for="item.key"
    :class="[
      item.labelClassName,
      { hidden: item.hidden },
      { disable: item.disable },
      `checkbox-item`,
      { 'highlight-chk': item.highlight },
    ]"
  >
    <input
      type="checkbox"
      :checked="item.checked"
      :id="item.key"
      :value="item.value"
      :name="item.name"
      :disabled="item.disable"
      @click="clickHandler(item.key)"
      @touchstart="clickHandler(item.key)"
      @change="changeHandler(item.key, item.selectAll)"
    />
    <span class="mark" :class="{ active: item.checked }"></span>
    <img
      v-if="item.icon"
      :src="item.icon"
      style="width: 20px; margin-left: 10px"
    />
    <span class="label" :style="labelStyle">{{ $t(item.value) }}</span>
  </label>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";
const props = defineProps({
  items: Array,
  labelStyle: Object,
});

const emit = defineEmits(["onChange", "onClick"]);
const clickHandler = (key) => {
  emit("onClick", key);
};

const changeHandler = (key, selectAll) => {
  const selectedItem = props.items.find((ob) => ob.key == key);

  if (selectAll) {
    // 'all' 체크박스의 상태 변경 처리
    if (selectedItem.checked) {
      // 'all' 체크박스가 체크된 상태면 전체 해제
      props.items.forEach((item) => {
        item.checked = false;
      });
    } else {
      // 'all' 체크박스가 해제된 상태면 전체 선택
      props.items.forEach((item) => {
        item.checked = true;
      });
    }
  } else {
    // 개별 체크박스 상태 변경
    selectedItem.checked = !selectedItem.checked;

    // 하나라도 체크가 해제되면 'all_smart' 체크박스도 해제
    const allChecked = props.items
      .filter((item) => !item.selectAll)
      .every((item) => item.checked); // 모든 개별 항목이 체크되었는지 확인

    if (!allChecked) {
      const allSelect = props.items.find((item) => item.selectAll);
      if (allSelect) {
        allSelect.checked = false; // 개별 항목이 해제되면 'all_smart' 체크 해제
      }
    } else {
      // 모든 개별 항목이 체크되었을 경우 'all_smart' 체크
      const allSelect = props.items.find((item) => item.selectAll);
      if (allSelect) {
        allSelect.checked = true;
      }
    }
  }

  // emit event
  emit(
    "onChange",
    {
      all: props.items,
      selected: selectedItem,
      unSelected: props.items.filter((ob) => !ob.checked),
    },
    key
  );
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/ui/checkBox.scss";
</style>
